<template>
  <v-container 
      class="ma-0 pa-0"
      fluid
      style="height: calc(100vh - 96px); max-height: calc(100vh - 96px); overflow-y: hidden; width: 100%">
    <div v-if="showAlert">
      <v-alert
        class="v-alert alert_overlay"
        v-model="showAlert"
        border="left"
        close-text="Close Alert"
        dismissible
        :type="alertType"
      >
        {{ alertMsg }}
      </v-alert>
    </div>

    <v-row class="ma-0 pa-0" style="height: 100%">
      <v-col cols="12" class="ma-0 pa-0" style="height: 100%">
        <v-row style="min-height: 10%; max-height: 20" class="ma-0 px-6 pt-4 pb-2">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row width="100%" class="ma-0 pa-0" align="center" style="min-height: 60px;">
              <v-col cols="auto" class="ma-0 pa-0">
                <v-img :src="main_logo" max-height="48px" max-width="80px" contain></v-img>
              </v-col>
              <v-col cols="auto" class="ma-0 pa-0">
                <span class="page-title">Admin</span>
              </v-col>
            </v-row>
            <v-row width="100%" class="ma-0 pa-0">
              <v-tabs v-model="admin_tab" align-tabs="start" light>
                <v-tab class="tool-navigation-bar" href="#user_directory">User Directory</v-tab>
                <v-tab class="tool-navigation-bar" href="#project_directory">Project Directory</v-tab>
              </v-tabs>
            </v-row>
          </v-col>
        </v-row>
      <!-- </v-col>
      <v-col> -->
        <v-row class="ma-0 pa-0">
          <!-- <v-col cols="auto">
            <v-chip
              label
              class="data_breakdown_chip"
              :outlined="admin_tab != 'user_directory'"
              @click="admin_tab = 'user_directory'"
              color="black"
              >User Directory</v-chip
            >
            <v-chip
              label
              class="data_breakdown_chip"
              :outlined="admin_tab != 'project_directory'"
              @click="admin_tab = 'project_directory'"
              color="black"
              >Project Directory</v-chip
            >
          </v-col> -->
          <v-col cols="12" v-if="admin_tab == 'user_directory'">
            <UserDirectory v-on:triggerAlert="triggerAlert" />
          </v-col>
          <v-col cols="12" v-else>
            <ProjectDirectory v-on:triggerAlert="triggerAlert" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserDirectory from "./AdminComponents/UserDirectory.vue";
import ProjectDirectory from "./AdminComponents/ProjectDirectory.vue";
import logo from "@/assets/PlanningLogo.svg";

export default {
  name: "AdminPage",
  props: [],
  components: {
    UserDirectory,
    ProjectDirectory,
  },
  beforeDestroy() {
    clearTimeout(this.alertTimeout);
  },
  data: () => ({
    alertMsg: null,
    alertType: null,
    showAlert: false,
    alertTimeout: null,
    admin_tab: "user_directory",
    main_logo: logo,
  }),
  methods: {
    triggerAlert: function (type, message) {
      this.alertType = type ? type : "info";
      this.alertMsg = message;
      this.showAlert = true;
      clearTimeout(this.alertTimeout);
      this.alertTimeout = setTimeout(() => {
        this.showAlert = false;
        this.alertTimeout = null;
      }, 5000);
    },
  },
};
</script>

<style>
  .page-title {
    font-family: "Poppins" !important;
    font-weight: 800;
    font-size: 2em;
  }
  .section-title {
    font-family: "Poppins" !important;
    font-weight: 400 !important;
    font-size: 1.5em !important;
    margin-top: 10px;

    display: flex;
  }
  .tool-navigation-bar {
    font-family: "Poppins" !important;
    font-weight: 400 !important;
    font-size: 0.9em !important;
  }
  .v-overlay__content {
    width: 100%;
    height: unset !important;
  }
  .alert_overlay {
    position: absolute;
    width: 100%;
    z-index: 99;
  }
</style>
